export default (string, a, b, c = 'en') => (string ? string.replace(a, b) : c);
